import React from 'react';
import { observer } from 'mobx-react-lite';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, useTheme } from '@privemind/components';
import { usePortfolioAuth } from '../../lib/use-portfolio-auth';
import './navigation.scss';

export const Navigation: React.FC = observer(() => {
  const location = useLocation();
  const navigate = useNavigate();
  const auth = usePortfolioAuth();
  const theme = useTheme();

  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path);
  };

  const handleAuthAction = () => {
    if (auth.isAuthenticated) {
      auth.logout();
    } else {
      auth.showLogin();
    }
  };

  return (
    <nav 
      className="navigation"
      style={{
        borderBottomColor: theme.colors.secondary.dark,
      }}
    >
      <div className="navigation__buttons">
        <Button
          color={isActive('/') && location.pathname === '/' ? 'primary' : 'secondary'}
          onClick={() => navigate('/')}
          className="navigation__button"
        >
          Home
        </Button>
        <Button
          color={isActive('/edit-assets') ? 'primary' : 'secondary'}
          onClick={() => navigate('/edit-assets')}
          className="navigation__button"
        >
          Edit Assets
        </Button>
        <Button
          color={isActive('/stats') ? 'primary' : 'secondary'}
          onClick={() => navigate('/stats')}
          className="navigation__button"
        >
          Stats
        </Button>
      </div>
      
      <div className="navigation__auth">
        {auth.isAuthenticated ? (
          <div className="navigation__user-info">
            <span 
              className="navigation__username"
              style={{
                color: theme.colors.secondary.normal,
              }}
            >
              {auth.currentUser?.username}
            </span>
            <Button
              color="secondary"
              onClick={handleAuthAction}
              className="navigation__auth-button"
              size="sm"
            >
              Logout
            </Button>
          </div>
        ) : (
          <Button
            color="primary"
            onClick={handleAuthAction}
            className="navigation__auth-button"
          >
            Sign in/Register
          </Button>
        )}
      </div>
    </nav>
  );
});
